// src/services/subPlans.ts
//
// Sub-plans-domain service. Groups the auxiliary client plans that live
// alongside the meal plan: dietary guidelines (with file upload + categories),
// exercises (with type list), supplements, and daily water intake.

import { apiFetch } from "../Component/api/apiFetch";
import { API_URLS } from "../Component/api/url";
import { handleJson } from "./http";

export const getAllGuidelines = (
  userId: string | number,
  status: string
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_ALL_GUIDELINES(userId, status), { method: "GET" })
  );

export const uploadGuideline = (formData: FormData): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.UPLOAD_GUIDELINE, { method: "POST", body: formData })
  );

export const getAllGuidelineCategories = (): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_ALL_GUIDELINE_CATEGORIES, { method: "GET" })
  );

export const getAllExercises = (userId: string | number): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_ALL_EXERCISES(userId), { method: "GET" })
  );

export const createExercise = (
  userId: string | number,
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.CREATE_EXERCISE(userId), {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const getAllExerciseTypeList = (): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_ALL_EXERCISE_TYPE_LIST, { method: "GET" })
  );

export const getAllSupplements = (userId: string | number): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_ALL_SUPPLEMENTS(userId), { method: "GET" })
  );

export const addSupplement = (payload: Record<string, any>): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.ADD_SUPPLEMENT, {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const getWaterIntakeDetails = (userId: string | number): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_WATER_INTAKE_DETAILS(userId), { method: "GET" })
  );

export const createWaterIntake = (
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.CREATE_WATER_INTAKE, {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );
